/**
 * SEARCH ROUTES
 */

export default [
  {
    path: '/:lang?/search',
    name: 'view-search',
    component: () => import(/* webpackChunkName: "search" */ '@/views/Search.vue'),
    meta: { layout: 'search' },
    children: [
      {
        path: ':mediatype',
        name: 'view-search-list',
        component: () => import('@/views/search/sections/ResultsList.vue'),
      },
      {
        path: 'similar/:mediatype',
        name: 'view-search-similar',
        component: () => import('@/views/search/similar/SimilarResults.vue'),
      },
    ],
  },
  // {
  //   path: '/',
  //   redirect: '/search/video',
  //   meta: { layout: 'search' },
  // },
  // {
  //   path: '*',
  //   redirect: '/search/video',
  //   meta: { layout: 'search' },
  // },
];
